/**
 * kategorie-meta.ts — the 7 relation-kategorie descriptors (Story UI-U8).
 *
 * Ported from the prototype's CATEGORY_META. Colours come from the NEW `rel-*`
 * tokens ONLY (design.md §2/§7 — a categorical palette kept separate from the
 * status ampel). Class names are LITERAL strings (Tailwind JIT-safe).
 *
 * [Source: brokly-design-reference/components/brokly/kunde-struktur-tab.tsx CATEGORY_META]
 */

import { Building2, UserRound, Handshake, Waypoints, ShieldCheck } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { RelKategorie } from '@brokly/shared';

export interface KategorieMeta {
  label: string;
  plural: string;
  Icon: LucideIcon;
  dot: string;
  text: string;
  border: string;
  stroke: string;
  hint: (kunde: string) => string;
}

export const KATEGORIE_META: Record<RelKategorie, KategorieMeta> = {
  mutter: {
    label: 'Mutterunternehmen',
    plural: 'Mutterunternehmen',
    Icon: Building2,
    dot: 'bg-rel-mutter',
    text: 'text-rel-mutter',
    border: 'border-rel-mutter',
    stroke: 'stroke-rel-mutter',
    hint: (k) => `Hält eine Mehrheit an ${k}.`,
  },
  schwester: {
    label: 'Schwestergesellschaft',
    plural: 'Schwestergesellschaften',
    Icon: Building2,
    dot: 'bg-rel-schwester',
    text: 'text-rel-schwester',
    border: 'border-rel-schwester',
    stroke: 'stroke-rel-schwester',
    hint: () => 'Teilt dieselbe Muttergesellschaft.',
  },
  tochter: {
    label: 'Tochtergesellschaft',
    plural: 'Tochtergesellschaften',
    Icon: Building2,
    dot: 'bg-rel-tochter',
    text: 'text-rel-tochter',
    border: 'border-rel-tochter',
    stroke: 'stroke-rel-tochter',
    hint: (k) => `Wird von ${k} kontrolliert.`,
  },
  person: {
    label: 'Wirtschaftlich berechtigte Person',
    plural: 'Wirtschaftlich Berechtigte',
    Icon: UserRound,
    dot: 'bg-rel-person',
    text: 'text-rel-person',
    border: 'border-rel-person',
    stroke: 'stroke-rel-person',
    hint: () => 'GwG-relevante natürliche Personen mit Beteiligung.',
  },
  cobroker: {
    label: 'Co-Broker / Vermittler',
    plural: 'Co-Broker / Vermittler',
    Icon: Handshake,
    dot: 'bg-rel-cobroker',
    text: 'text-rel-cobroker',
    border: 'border-rel-cobroker',
    stroke: 'stroke-rel-cobroker',
    hint: () => 'Weitere Broker oder Vermittler mit Bezug zum Kunden.',
  },
  partner: {
    label: 'Geschäftspartner',
    plural: 'Geschäftspartner',
    Icon: Waypoints,
    dot: 'bg-rel-partner',
    text: 'text-rel-partner',
    border: 'border-rel-partner',
    stroke: 'stroke-rel-partner',
    hint: () => 'Kooperationen ohne Kapitalverbindung.',
  },
  buergschaft: {
    label: 'Bürgschaft / Garantie',
    plural: 'Bürgschaften / Garantien',
    Icon: ShieldCheck,
    dot: 'bg-rel-buergschaft',
    text: 'text-rel-buergschaft',
    border: 'border-rel-buergschaft',
    stroke: 'stroke-rel-buergschaft',
    hint: () => 'Besicherungen zwischen Gesellschaften.',
  },
};
